'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _axwayReactIntl = require('axway-react-intl');

var _axwayReactIntl2 = _interopRequireDefault(_axwayReactIntl);

var _JsonSchema = require('../JsonSchema');

var _JsonSchema2 = _interopRequireDefault(_JsonSchema);

var _util = require('./util');

var _HTTPResponseLabel = require('../HTTPResponseLabel');

var _HTTPResponseLabel2 = _interopRequireDefault(_HTTPResponseLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EXTENSION_PATTERN = /^x-/;

/**
 *
 */

var MethodResponses = function (_React$Component) {
	_inherits(MethodResponses, _React$Component);

	function MethodResponses(props) {
		_classCallCheck(this, MethodResponses);

		var _this = _possibleConstructorReturn(this, (MethodResponses.__proto__ || Object.getPrototypeOf(MethodResponses)).call(this, props));

		_axwayReactIntl2.default.init(_this);
		return _this;
	}

	_createClass(MethodResponses, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    doc = _props.doc,
			    method = _props.method;

			var responses = [];
			Object.keys(method.responses).filter(function (code) {
				return !EXTENSION_PATTERN.test(code);
			}).forEach(function (code) {
				var response = method.responses[code];
				var schema = response.schema;
				if (schema && schema.$ref) {
					schema = (0, _util.deref)(doc, schema);
				}
				responses.push(_react2.default.createElement(
					'li',
					{ key: code },
					_react2.default.createElement(_HTTPResponseLabel2.default, { code: code }),
					schema && _react2.default.createElement(
						'div',
						{ className: 'schema' },
						_react2.default.createElement(_JsonSchema2.default, {
							title: response.description,
							expandable: true,
							expanded: false,
							schema: schema,
							levels: 10
						})
					),
					!schema && response.description && _react2.default.createElement(
						'div',
						{ className: 'http-response-not-collapsible' },
						response.description
					)
				));
			});

			return _react2.default.createElement(
				'div',
				{ className: 'ux-container' },
				_react2.default.createElement(
					'h4',
					null,
					this.intl.formatMsg('HTTP responses')
				),
				_react2.default.createElement(
					'ul',
					null,
					responses
				)
			);
		}
	}]);

	return MethodResponses;
}(_react2.default.Component);

MethodResponses.propTypes = {
	/**
  * Swagger 2.0 method
  */
	method: _propTypes2.default.object.isRequired,

	/**
  * Valid swagger 2.0 document
  */
	doc: _propTypes2.default.object.isRequired
};

var _default = (0, _reactIntl.injectIntl)(MethodResponses);

exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(EXTENSION_PATTERN, 'EXTENSION_PATTERN', 'src/components/SwaggerUI/MethodResponses.jsx');

	__REACT_HOT_LOADER__.register(MethodResponses, 'MethodResponses', 'src/components/SwaggerUI/MethodResponses.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/SwaggerUI/MethodResponses.jsx');
}();

;